import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { Common } from 'ws-scripts/modules/common';
import Main from '../components/Main';

export class WidgetContainer extends React.Component {
	render() {
		const { vehicleViews, numberOfDays } = this.props;
		return (
			<Common
				render={({ prefs, labels }) => {
					if (vehicleViews >= prefs.minimumViews) {
						return (
							<Main
								vehicleViews={vehicleViews}
								numberOfDays={numberOfDays}
								prefs={prefs}
								labels={labels}
							/>
						);
					}
					return null;
				}}
			/>
		);
	}
}

WidgetContainer.propTypes = {
	vehicleViews: PropTypes.number.isRequired,
	numberOfDays: PropTypes.number.isRequired
};

const mapStateToProps = state => {
	return {
		vehicleViews: state.vehicleViews,
		numberOfDays: state.numberOfDays
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx